import React from "react";
import * as Icons from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function WhyChooseUs() {
  const { content } = useContent();
  const { whyChooseUs, processSteps } = content;
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-b from-white to-emerald-50/40">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-block px-3 py-1 rounded-full bg-orange-50 text-orange-600 text-xs font-semibold tracking-wider mb-4">
            WHY CHOOSE US
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
            Solar Done <span className="text-orange-500">Right</span>
          </h2>
          <p className="text-slate-600 mt-4">
            Six reasons thousands of Indian homeowners trust Zenova with their rooftops.
          </p>
        </div>

        {/* Hexagon-ish grid like the original */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {whyChooseUs.map((f) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div
                key={f.title}
                className="group flex flex-col items-center text-center px-3 py-6 rounded-2xl bg-white border border-slate-200 hover:border-orange-300 hover:shadow-lg transition-all"
              >
                <div className="relative w-20 h-20 mb-3 flex items-center justify-center">
                  <div className="absolute inset-0 bg-emerald-100/70 group-hover:bg-orange-100 transition-colors"
                    style={{ clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)" }}
                  />
                  <Icon className="w-8 h-8 text-[#0a4f47] group-hover:text-orange-600 relative z-10 transition-colors" />
                </div>
                <div className="font-bold text-slate-900 text-sm leading-tight">{f.title}</div>
                <div className="text-xs text-slate-600 mt-2 leading-snug">{f.text}</div>
              </div>
            );
          })}
        </div>

        {/* Process timeline */}
        <div className="mt-24">
          <div className="text-center max-w-2xl mx-auto">
            <div className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-[#0a4f47] text-xs font-semibold tracking-wider mb-4">
              HOW IT WORKS
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
              From Enquiry to <span className="text-orange-500">Energized</span> in 30 Days
            </h2>
          </div>
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {processSteps.map((p) => (
              <div
                key={p.step}
                className="group relative bg-white rounded-xl p-6 border border-slate-200 hover:border-[#0a4f47] hover:shadow-md transition-all"
              >
                <div className="text-5xl font-extrabold text-orange-100 group-hover:text-orange-200 transition-colors leading-none">
                  {p.step}
                </div>
                <h3 className="mt-3 text-lg font-bold text-slate-900">{p.title}</h3>
                <p className="text-sm text-slate-600 mt-2">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
